import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export interface GlobalLoadingState {
  enabled: boolean;
  isLoading: boolean;
  progressPercent?: number;
}

const initialState: GlobalLoadingState = {
  enabled: true,
  isLoading: false,
  progressPercent: undefined,
};

export const globalLoadingSlice = createSlice({
  name: 'globalLoading',
  initialState,
  reducers: {
    setGlobalLoadingEnabled: (state, action: PayloadAction<{ enabled: boolean }>) => {
      state.enabled = action.payload.enabled;
    },
    setGlobalLoadingIsLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isLoading = action.payload.isLoading;
    },
    setGlobalLoadingProgressPercent: (state, action: PayloadAction<{ progressPercent?: number }>) => {
      state.progressPercent = action.payload.progressPercent;
    },
  },
});

export const { setGlobalLoadingEnabled, setGlobalLoadingIsLoading, setGlobalLoadingProgressPercent } =
  globalLoadingSlice.actions;

export const globalLoadingEnabledSelector = (state: RootState) => state.globalLoading.enabled;

export const globalLoadingIsLoadingSelector = (state: RootState) => state.globalLoading.isLoading;

export const globalLoadingProgressPercentSelector = (state: RootState) => state.globalLoading.progressPercent;

export default globalLoadingSlice.reducer;
